<template>
  <div id="sistem-pengawasan">

    <banner
      title="Sistem Pengaduan"
      description="Laporkan masalah terkait buku pelajaran Kemendikbud disini. Setiap laporan sangat berguna untuk meningkatkan kualitas buku Pelajaran Sekolah"
      :breadcrumbs="breadcrumbs"
      :icon="require('@/assets/sistem-pengawasan/decoration/Vector.svg')"
    />

    <section id="content" class="mt-4 px-3 px-lg-5">
      <div class="card p-3 border-0 shadow-sm">
        <div class="card border-0 shadow-sm p-3 bg-primary-20">
          <h4 class="text-secondary">Nomor Laporan #{{ report.nomor_aduan }}</h4>
          <h4>{{ report.judul }}</h4>
        </div>
        <div class="row mt-5">
          <div class="col-lg-6">
            <div class="card border-0 bg-primary-50 p-4 rounded">
              <h4 class="font-weight-bold">Informasi</h4>
              <div class="row mt-4">
                <div class="col-lg-6 mb-4">
                  <div class="d-flex">
                    <div class="bg-white rounded d-flex align-items-center justify-content-center" style="width: 50px; height: auto">
                      <i class="fa fa-xl fa-book-open text-primary"></i>
                    </div>
                    <div class="ml-3">
                      <h6 class="text-muted">Status</h6>
                      <div class="bg-success-50 text-success px-2 py-1 rounded">{{ report.status }}</div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6 mb-4">
                  <div class="d-flex mr-5">
                    <div class="bg-white rounded d-flex align-items-center justify-content-center" style="width: 50px; height: auto">
                      <i class="fa fa-xl fa-book text-primary"></i>
                    </div>
                    <div class="ml-3">
                      <h6 class="text-muted">Jenis Buku</h6>
                      <div class="py-1">Buku teks Utama</div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="d-flex mr-5">
                    <div class="bg-white rounded d-flex align-items-center justify-content-center" style="width: 50px; height: auto">
                      <i class="fa fa-xl fa-circle-exclamation text-primary"></i>
                    </div>
                    <div class="ml-3">
                      <h6 class="text-muted">Masalah</h6>
                      <div class="py-1">{{ report.kategori }}</div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="d-flex mr-5">
                    <div class="bg-white rounded d-flex align-items-center justify-content-center" style="width: 50px; height: auto">
                      <i class="fa fa-xl fa-calendar-alt text-primary"></i>
                    </div>
                    <div class="ml-3">
                      <h6 class="text-muted">Tanggal</h6>
                      <div class="py-1">{{ report.created_at }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="card border-0 bg-primary-50 p-4 rounded">
              <h4 class="font-weight-bold">Identitas</h4>
              <div class="row mt-4">
                <div class="col-lg-6 mb-4">
                  <div class="d-flex">
                    <div class="bg-white rounded d-flex align-items-center justify-content-center" style="width: 50px; height: auto">
                      <i class="fa fa-xl fa-user text-primary"></i>
                    </div>
                    <div class="ml-3">
                      <h6 class="text-muted">Nama</h6>
                      <div class="py-1">{{ report.pelapor }}</div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6 mb-4">
                  <div class="d-flex">
                    <div class="bg-white rounded d-flex align-items-center justify-content-center" style="width: 50px; height: auto">
                      <i class="fa fa-xl fa-envelope text-primary"></i>
                    </div>
                    <div class="ml-3">
                      <h6 class="text-muted">Email</h6>
                      <div class="py-1">Privat</div>
                    </div>
                  </div>
                </div>
                <!-- <div class="col-lg-6 mb-4">
                  <div class="d-flex mr-5">
                    <div class="bg-white rounded d-flex align-items-center justify-content-center" style="width: 50px; height: auto">
                      <i class="fa fa-xl fa-envelope text-primary"></i>
                    </div>
                    <div class="ml-3">
                      <h6 class="text-muted">Email</h6>
                      <div class="py-1">{{ report.email }}</div>
                    </div>
                  </div>
                </div> -->
                <div class="col-lg-6">
                  <div class="d-flex mr-5">
                    <div class="bg-white rounded d-flex align-items-center justify-content-center" style="width: 50px; height: auto">
                      <i class="fa fa-xl fa-phone text-primary"></i>
                    </div>
                    <div class="ml-3">
                      <h6 class="text-muted">Telepon</h6>
                      <div class="py-1">Privat</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card border-0 shadow-sm p-3 bg-primary-20 mt-3">
          <h4>Bukti Pendukung</h4>
          <div v-if="report?.lampiran" class="d-flex mt-3" style="gap: 1rem;">
            <img :src="`https://static.sc.cloudapp.web.id/uploader/files/${report.lampiran}`" width="350" height="350" style="object-fit: cover;" alt="">
          </div>
          <div v-if="report?.tautan" class="d-flex mt-3" style="gap: 1rem;">
            <a :href="report.tautan" target="_blank" class="btn btn-outline-primary">Lihat Tautan Bukti Pendukung</a>
          </div>
        </div>
        <p class="lead my-3">Terima kasih atas laporannya. Selanjutnya laporan akan kami proses dan mengirimkannya hasilnya kepada Anda</p>
        <div class="d-flex justify-content-end mt-3">
          <button class="btn btn-outline-secondary px-5 mr-3" onclick="print();">Print</button>
          <button type="button" class="btn btn-secondary px-5" data-toggle="modal" data-target="#exampleModal">Sunting</button>
        </div>
      </div>
    </section>

    <section  id="content" class="px-3 px-lg-5 mt-10">
      <div class="text-center">
        <h1 class="font-weight-bold mb-3">Laporan Terbaru</h1>
        <p class="lead text-muted">Temukan laporan terbaru dari pengguna disinil</p>
      </div>
      <div class="my-3">
        <div v-for="report in reports" :key="report.id" class="card border-0 rounded shadow-sm p-3 bg-primary-20 mb-4">
          <router-link :to="`/sistem-pengawasan/laporan/${report.id}`" class="text-dark text-decoration-none">
            <div class="d-flex justify-content-between mb-2">
              <h3 class="text-dark mb-0">{{ report.judul }}</h3>
              <div class="text-muted">{{ report.created_at }}</div>
            </div>
            <p class="lead text-muted">{{ report.isi }}</p>
            <div class="d-flex justify-content-between">
              <div class="d-flex align-items-center">
                <img :src="`https://ui-avatars.com/api/?name=${report.pelapor}&background=344054&color=fff&font-size=0.40`" alt="Avatar" class="mr-3 rounded-circle">
                <h6 class="m-0">{{ report.pelapor }}</h6>
              </div>
              <div class="d-flex align-items-center bg-primary-30 rounded p-3">
                <div class="text-primary mr-3"><i class="fa-regular fa-circle-check"></i> Terverifikasi</div>
                <div class="text-primary mr-3"><i class="fa-regular fa-file-alt"></i> Tindak Lanjut</div>
                <!-- <div class="text-primary mr-3"><i class="fa-regular fa-comments"></i> Komentar</div>
                <div class="text-primary"><i class="fa-regular fa-thumbs-up"></i> Dukungan</div> -->
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </section>

    <CTA/>

    <!-- Modal -->
    <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Sunting Laporan</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="submitReport">
              <h5 class="my-3">Data Identitas</h5>
              <div class="row">
                <div class="col-lg-6 mb-2">
                  <div class="form-group">
                    <label for="nama-lengkap" class="form-label">Nama Lengkap <span class="text-danger">*</span></label>
                    <input
                      v-model="report.pelapor"
                      id="nama-lengkap"
                      type="text"
                      class="form-control"
                      placeholder="Masukkan nama lengkap"
                      required
                    />
                  </div>
                </div>
                <div class="col-lg-6 mb-2">
                  <div class="form-group">
                    <label for="pekerjaan" class="form-label">Status <span class="text-danger">*</span></label>
                    <select class="form-control" id="pekerjaan" v-model="report.pekerjaan">
                      <option value="Guru">Guru</option>
                      <option value="Siswa">Siswa</option>
                      <option value="Masyarakat">Masyarakat</option>
                      <option value="Dinas">Dinas</option>
                      <option value="Orangtua">Orangtua</option>
                      <option value="Lain-lain">Lain-lain</option>
                    </select>
                  </div>
                </div>
                <div class="col-lg-6 mb-2">
                  <div class="form-group">
                    <label for="kontak" class="form-label">Kontak <span class="text-danger">*</span></label>
                    <input
                      v-model="report.telepon"
                      id="kontak"
                      type="text"
                      inputmode="numeric"
                      class="form-control"
                      placeholder="Misalnya nomor whatsapp"
                      required
                    />
                    <div class="text-small mt-2">Catatan : Kami butuhkan untuk umpan balik.</div>
                  </div>
                </div>
                <div class="col-lg-6 mb-2">
                  <div class="form-group">
                    <label for="email" class="form-label">Email <span class="text-danger">*</span></label>
                    <input
                      v-model="report.email"
                      id="email"
                      type="email"
                      class="form-control"
                      placeholder="Masukkan email"
                      required
                    />
                  </div>
                </div>
              </div>
              <h5 class="my-3">Data Laporan</h5>
              <div class="row">
                <div class="col-lg-6 mb-2">
                  <div class="form-group">
                    <label for="judulLaporan" class="form-label">Judul <span class="text-danger">*</span></label>
                    <input
                      v-model="report.judul"
                      id="judulLaporan"
                      type="text"
                      class="form-control"
                      placeholder="Masukkan judul laporan"
                      required
                    />
                  </div>
                </div>
                <div class="col-lg-6 mb-2">
                  <div class="form-group">
                    <label for="jenis-buku" class="form-label">Jenis Buku <span class="text-danger">*</span></label>
                    <select class="form-control" id="jenis-buku">
                      <option value="Buku Teks Utama">Buku Teks Utama</option>
                      <option value="Buku Teks Pelajaran">Buku Teks Pelajaran</option>
                      <option value="Buku Nonteks">Buku Nonteks</option>
                    </select>
                  </div>
                </div>
                <div class="col-lg-6 mb-2">
                  <div class="form-group">
                    <label for="buku" class="form-label">Buku <span class="text-danger">*</span></label>
                    <select name="buku" id="buku" class="form-control">
                      <option v-for="book in books" :key="book.id" :value="book.title">{{ book.title }}</option>
                    </select>
                  </div>
                </div>
                <div class="col-lg-6 mb-2">
                  <div class="form-group">
                    <label for="jenjang" class="form-label">Jenjang <span class="text-danger">*</span></label>
                    <select class="form-control" id="jenjang">
                      <option value="SD">SD</option>
                      <option value="SMP">SMP</option>
                      <option value="SMA">SMA</option>
                    </select>
                  </div>
                </div>
                <div class="col-lg-6 mb-2">
                  <div class="form-group">
                    <label for="kelas" class="form-label">Kelas <span class="text-danger">*</span></label>
                    <select class="form-control" id="kelas">
                      <option value="I">I</option>
                      <option value="II">II</option>
                      <option value="III">III</option>
                      <option value="IV">IV</option>
                      <option value="V">V</option>
                      <option value="VI">VI</option>
                      <option value="VII">VII</option>
                      <option value="VIII">VIII</option>
                      <option value="IX">IX</option>
                      <option value="X">X</option>
                      <option value="XI">XI</option>
                      <option value="XII">XII</option>
                    </select>
                  </div>
                </div>
                <div class="col-lg-6 mb-2">
                  <div class="form-group">
                    <label for="masalah" class="form-label">Masalah <span class="text-danger">*</span></label>
                    <select v-model="report.kategori" class="form-control" id="masalah">
                      <option value="Kualitas Cetak">Kualitas Cetak</option>
                      <option value="Distribusi">Distribusi</option>
                      <option value="Harga Eceran Tertinggi (HET)">Harga Eceran Tertinggi (HET)</option>
                      <option value="Pengadaan">Pengadaan</option>
                      <option value="Salah Cetak">Salah Cetak</option>
                      <option value="Bahasa">Bahasa</option>
                      <option value="Kualitas Konten">Kualitas Konten</option>
                      <option value="Legalitas">Legalitas</option>
                      <option value="Kesesuaian Kurikulum">Kesesuaian Kurikulum</option>
                    </select>
                  </div>
                </div>
                <div class="col-lg-12 mb-2">
                  <div class="form-group">
                    <label for="deskripsi" class="form-label">Jelaskan masalah yang terjadi dengan lengkap <span class="text-danger">*</span></label>
                    <textarea
                      v-model="report.isi"
                      id="deskripsi"
                      class="form-control"
                      placeholder="Masukkan deskripsi masalah"
                      rows="5"
                      required
                    ></textarea>
                  </div>
                </div>
                <div class="col-lg-12 mb-2">
                  <div class="form-group">
                    <label for="lampiran" class="form-label">Lampiran Bukti Pendukung</label>
                    <FileUploader
                      @select-file="setFile($event, 'lampiran')"
                      :uploaded="report.lampiran"
                      id="lampiran"
                    />
                    <div class="text-muted small mt-2">
                      Format <b>PDF, JPG, PNG</b> Ukuran Maks 1 Mb
                    </div>
                  </div>
                  <div class="my-1">
                    <button
                      v-if="!loading.lampiran"
                      @click="uploadingFile('lampiran')"
                      type="button"
                      class="btn btn-primary w-100 btn-sm"
                      id="uploadLampiran"
                    >
                      Unggah
                    </button>
                    <button
                      v-if="loading.lampiran"
                      type="button"
                      class="btn btn-primary w-100 btn-sm"
                    >
                      <div
                        class="spinner-border spinner-border-sm"
                        role="status"
                      >
                        <span class="sr-only">Loading...</span>
                      </div>
                    </button>
                  </div>
                </div>
                <div class="col-12 mb-3">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      @change="!report.accept_tnc"
                      v-model="report.accept_tnc"
                      type="checkbox"
                      id="accept"
                    />
                    <label class="form-check-label" for="accept">
                      Saya menyetujui syarat dan ketentuan yang berlaku. <span class="text-danger">*</span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-end">
                <button type="button" class="btn btn-outline-secondary px-5 mr-3" data-dismiss="modal" aria-label="Close">Batal</button>
                <button type="button" class="btn btn-secondary px-4">Kirim data</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<style scoped>
.sidebar {
  border: 1px solid #dbddf0;
  border-radius: 0.5rem;
  padding: 1rem;
}
</style>
<script>
import Banner from "../../components/homepage/Banner.vue";
import FileUploader from "../../components/global/dashboard/FileUploader.vue";
import CTA from "../../components/sistem-pengawasan/CTA.vue";
import { BASE_URL } from "../../store";
import axios from "axios";
import { mapActions } from "vuex";
import Swal from "sweetalert2";

export default {
  components: { Banner, CTA, FileUploader },
  watch: {
    filter() {
      this.pageNumber = 1;
    },
  },
  data() {
    return {
      books: [],
      reports : [],
      report: {
        judul: "",
        kategori: "Salah Cetak",
        materi: "",
        isi: "",
        pelapor: "",
        pekerjaan: "Guru",
        telepon: "",
        email: "",
        lampiran: null,
        accept_tnc: false,
      },
      file: {
        lampiran: null,
      },
      loading: {
        lampiran: false,
      },
      link: {
        lampiran: "",
      },
      breadcrumbs: [
        {
          label: "Beranda",
          url: "/",
        },
        {
          label: "Sistem Pengaduan",
          url: "",
        },
      ],
    };
  },
  methods: {
    ...mapActions(["uploadFile"]),
    setFile(file) {
      this.file = file;
    },
    uploadingFile() {
      if (this.file === null) {
        Swal.fire({
          icon: "warning",
          title: "Perhatian",
          text: "Lampiran harus terisi.",
        });
      } else {
        if (this.file.size >= 10000000) {
          Swal.fire({
            icon: "warning",
            title: "Perhatian",
            text: "Ukuran berkas terlalu besar, maksimal 10 mb",
          });
        } else {
          this.uploadFile(this.file)
            .then((res) => {
              if (res.status === "success") {
                this.report.lampiran = res.file;
                Swal.fire({
                  icon: "success",
                  title: "Berhasil",
                  text: "Berkas lampiran berhasil diunggah."
                });
              } else {
                Swal.fire({
                  icon: "error",
                  title: res.message,
                });
              }
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: error.message,
              });
            });
        }
      }
    },
    submitReport() {

      if (!this.report.accept_tnc) {
        Swal.fire({
          icon: "warning",
          title: "Konfirmasi",
          text: "Sebelum melanjutkan, pelapor harus menyetujui dengan syarat dan ketentuan terlebih dahulu."
        })
        return
      }

      var body = new FormData();

      body.append("judul", this.report.judul);
      body.append("materi", this.report.materi);
      body.append("isi", this.report.isi);
      body.append("kategori", this.report.kategori);
      body.append("pelapor", this.report.pelapor);
      body.append("pekerjaan", this.report.pekerjaan);
      body.append("telepon", this.report.telepon);
      body.append("email", this.report.email);
      body.append("lampiran", this.report.lampiran);

      console.log(this.report)
      console.log(body)

      axios({
        url: BASE_URL + "api/pengaduan/insert",
        method: "POST",
        data: body,
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-type": "multipart/form-data",
        },
      })
      .then((response) => {
        if (response.data.status == "failed") {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Gagal mengirimkan laporan. Tunggu beberapa saat dan coba lagi, atau hubungi admin untuk mengatasi masalah ini.",
          });
        } else {
          Swal.fire({
            imageUrl:
              "https://ik.imagekit.io/8jggdaymrs/app.buku.kemendikdasmen.go.id/Done.png",
            imageAlt: "Done",
            title: "Terimakasih",
            text: "Laporan telah kami terima. Laporan ini akan sangat bermanfaat untuk kami.",
          }).then((status) => {
            if (status.isConfirmed || status.isDismissed) {
              this.$router.push(`/sistem-pengawasan/laporan/${response.data.inserted_id}`);
            }
          });
        }
      });
      
    },
  },
  created() {
    window.scrollTo({ top: "0", behavior: "smooth" });

    const id = this.$route.params.id
    axios.get(`${BASE_URL}api/pengaduan/detail/${id}`)
    .then((res) => {
      this.report = res.data.data
    })

    axios.get(`${BASE_URL}api/pengaduan`).then((res) => {
      if (res.data.status == "failed") {
        this.notFound = true;
      } else {
        this.reports = res.data.data;
        // console.log(this.reports)
      }
    })

    axios.get(`${BASE_URL}/api/catalogue/getPenggerakTextBooks?order_by=updated_at&sort=asc`).then((res) => {
      if (res.data.status == "success") {
        this.books = res.data.results;
      }
    })
  },
};
</script>
